import React from 'react';
import './ChatCard.css';

/**
 * Shared card component for chat message cards (events, rooms, etc.)
 *
 * @param {string|null} image - Image URL
 * @param {string} imageAlt - Alt text for image
 * @param {function} [onImageLoad] - Callback when image loads (e.g. scrollToBottom)
 * @param {function} [onClick] - If provided, card is clickable with pointer cursor
 * @param {React.ReactNode} children - Card content (title, details, etc.)
 */
const ChatCard = ({ image, imageAlt, onImageLoad, onClick, children }) => {
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    const placeholder = e.target.nextElementSibling;
    if (placeholder && placeholder.classList.contains('chat-card-image-placeholder')) {
      placeholder.style.display = 'flex';
    }
  };

  return (
    <div
      className={`chat-card${onClick ? ' clickable' : ''}`}
      onClick={onClick || undefined}
    >
      <div className="chat-card-image-wrapper">
        {image ? (
          <img
            src={image}
            alt={imageAlt}
            className="chat-card-image"
            loading="lazy"
            onLoad={onImageLoad}
            onError={handleImageError}
          />
        ) : null}
        <div
          className="chat-card-image-placeholder"
          style={{ display: image ? 'none' : 'flex' }}
        >
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M3 15L8 10L12 14L16 10L21 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
          </svg>
          <span>No image</span>
        </div>
      </div>
      <div className="chat-card-content">
        {children}
      </div>
    </div>
  );
};

export default React.memo(ChatCard);
